import { useEffect, useState } from 'react';
import { Button } from 'semantic-ui-react';
import VerifyDragDrop from './VerifyDragDrop';
import { observer } from 'mobx-react-lite';
import agent from './../../../../app/api/agent';
import { useStore } from '../../../../app/stores/store';
import { v4 as uuid } from 'uuid';
import { userLanguage } from '../../../../app/common/userLanguageSchema/userLanguage';
import { FileUploadInterface } from '../../../../app/models/Profile';

interface Props {
  nameData: string;
  workLevelIdForOrderRequest?: string;
  itemIdForOrderRequest?: string;
  itemIdForInward?: string;
}
const VerifyFileUpload = ({
  nameData,
  workLevelIdForOrderRequest,
  itemIdForOrderRequest,
  itemIdForInward,
}: Props) => {
  const {
    dashboardStore,
    commonStore,
    activityStore: { selectedActivity },
    WorkLevelStore,
  } = useStore();
  const [files, setFiles] = useState<File[]>([]);

  useEffect(() => {
    if (nameData !== 'verify') {
      WorkLevelStore.loadWorkLevelBasedOnItemLevel(selectedActivity?.id);
    }
    // eslint-disable-next-line
  }, [selectedActivity]);

  const onDrop = (acceptedFiles: File[]) => {
    setFiles(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      ),
    );
  };

  const upload = (e: any) => {
    e.preventDefault();
    let typeName = '';
    switch (nameData) {
      case 'verify':
        typeName = 'Verify Files ';
        break;
      case 'inward':
        typeName = 'Inward Request Files ';
        break;
      case 'order':
        typeName = 'Order Request Files ';
        break;
      default:
        typeName = '';
        break;
    }
    files.forEach(async (file) => {
      let FileNameChangedata: FileUploadInterface = {
        fileId: '',
        id: '',
        fileName: '',
        url: '',
      };
      if (commonStore.devEnv) {
        let item,
          workLevel = '';
        switch (nameData) {
          case 'verify':
            item = uuid();
            break;
          case 'order': {
            item = itemIdForOrderRequest;
            workLevel = workLevelIdForOrderRequest || '';
            break;
          }
          case 'inward':
            item = itemIdForInward;
            break;
          default:
            item = selectedActivity?.id;
            break;
        }
        if (nameData !== 'order') {
          workLevel = dashboardStore.dashboard.dashboardWorkLevelMaster?.id;
        }
        const response = await agent.Files.localFileUpload(
          file,
          workLevel,
          item,
        );
        const url = response?.data.path.replace(/\\\\/g, '\\');
        FileNameChangedata = {
          fileId: uuid(),
          id: response?.data.id,
          url: url,
          fileName: typeName.concat(new Date().toLocaleString()),
        };
        if (nameData === 'verify') {
          dashboardStore.dashboard.updateLocalFileAPI.push(response.data);
        }
      } else {
        const response = await agent.Files.uploadFile(file);
        FileNameChangedata = {
          fileId: uuid(),
          id: response.data.id,
          url: response.data.url,
          fileName: typeName.concat(new Date().toLocaleString()),
        };
      }

      // uploadURL(response.data)
      dashboardStore.setVerifyUrlResponse([
        ...dashboardStore.dashboard.verifyImageUrl,
        FileNameChangedata,
      ]);
      setFiles([]);
    });
  };

  return (
    <div
      style={
        workLevelIdForOrderRequest !== '' && itemIdForOrderRequest !== ''
          ? { pointerEvents: 'auto', opacity: '1', cursor: 'auto' }
          : {
              pointerEvents: 'none',
              opacity: '.7',
              cursor: 'not-allowed',
            }
      }
    >
      <VerifyDragDrop files={files} onDrop={onDrop} />
      <Button
        onClick={(e) => upload(e)}
        positive
        //Upload
      >
        {
          (userLanguage[0].Level3InventoryRecievingVerify?.IRVB04 as any)?.[
            `${commonStore.language.key}`
          ]
        }
      </Button>
    </div>
  );
};

export default observer(VerifyFileUpload);
